import { useState, useCallback, useMemo } from 'react';
import { TAB_CONFIG } from 'src/constants/config';

export const useTabManagement = (query = null, isExpert = false) => {
  // Calculate initial tab based on query and user type
  const getInitialTab = () => {
    if (!query) return null;
    if (query?.status === 'pending' || query?.status === 'successful') {
      return TAB_CONFIG.SUCCESSFUL.id;
    }
    // For other statuses, return the first available tab (EXPERT if status isn't 'new', otherwise null)
    return query?.status !== 'new' ? TAB_CONFIG.EXPERT.id : null;
  };

  const [activeTab, setActiveTab] = useState(getInitialTab);
  const [modalOpen, setModalOpen] = useState(false);

  // Determine available tabs based on query status and user type
  const availableTabs = useMemo(() => {
    if (!query) return [];

    const status = query?.status;
    const tabKeys = [];

    if (!isExpert) {
      // Add successful tab first for pending or successful status
      if (status === 'pending' || status === 'successful') {
        tabKeys.push('SUCCESSFUL');
      }

      // Add expert tab for all statuses except new
      if (status !== 'new') {
        tabKeys.push('EXPERT');
        tabKeys.push('EMAIL');
        tabKeys.push('SUBMIT');
      }

      // Add activity tab for all statuses except new and draft
      if (status !== 'new' && status !== 'draft') {
        tabKeys.push('ACTIVITY');
      }
    }

    return tabKeys.map((tabKey) => TAB_CONFIG[tabKey]);
  }, [query, isExpert]);

  const handleTabChange = useCallback((event, newValue) => {
    setActiveTab(newValue);
  }, []);

  const handleModalClose = useCallback(() => setModalOpen(false), []);
  const handleModalOpen = useCallback(() => setModalOpen(true), []);

  return {
    activeTab,
    availableTabs,
    modalOpen,
    handleTabChange,
    handleModalClose,
    handleModalOpen,
  };
};
